import { Box, Typography } from '@mui/material';
import { useChildTokens } from './useChildTokens';
import { formatTime, TimerViewProps, TIMER_SURFACE } from './timerView';

/**
 * Digital — bara siffrorna, ingen grafik.
 *
 * För ett barn som varken läser ring eller urtavla: stora mm:ss plus etikett, på
 * samma yta (TIMER_SURFACE) som de övriga formerna så att inget hoppar vid byte.
 * Här finns medvetet INGEN transition att dämpa — siffrorna byts en gång per
 * sekund och ingenting rör sig. Ren renderare: tiden kommer som prop, ingen egen
 * setInterval (se timerView.ts).
 */
const TimerDigital = ({ time, label, color, onToggle }: TimerViewProps) => {
  const tokens = useChildTokens();

  return (
    <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', py: 2.5 }}>
      <Box
        component="button"
        type="button"
        data-testid="timer-digital"
        onClick={onToggle}
        aria-label={label}
        sx={{
          width: '100%',
          maxWidth: 280,
          height: TIMER_SURFACE,
          px: 1,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          gap: 0.5,
          border: 'none',
          background: 'none',
          fontFamily: 'inherit',
          cursor: onToggle ? 'pointer' : 'default',
        }}
      >
        <Typography
          sx={{
            fontSize: '3.5rem',
            fontWeight: 900,
            lineHeight: 1,
            // Accentfärgen bär tiden här, eftersom ingen graf gör det.
            color,
            fontVariantNumeric: 'tabular-nums',
          }}
        >
          {formatTime(time)}
        </Typography>
        <Typography sx={{ fontSize: '0.85rem', fontWeight: 700, color: tokens.textSoft }}>
          {label}
        </Typography>
      </Box>
    </Box>
  );
};

export default TimerDigital;
